export const meebitsNFTs = [
  
  {
    id: 'meebits-10175',
    name: 'Meebits #10175',
    image: 'https://files.meebits.app/image/10175.png',
    price: '0.82 ETH'
  },
  {
    id: 'meebits-12243',
    name: 'Meebits #12243',
    image: 'https://files.meebits.app/image/12243.png',
    price: '0.95 ETH'
  },
  {
    id: 'meebits-4383',
    name: 'Meebits #4383',
    image: 'https://files.meebits.app/image/4383.png',
    price: '0.52 ETH'
  },
  {
    id: 'meebits-4545',
    name: 'Meebits #4545',
    image: 'https://files.meebits.app/image/4545.png',
    price: '0.73 ETH'
  },
  {
    id: 'meebits-8618',
    name: 'Meebits #8618',
    image: 'https://files.meebits.app/image/8618.png',
    price: '1.15 ETH'
  },
  {
    id: 'meebits-11120',
    name: 'Meebits #11120',
    image: 'https://files.meebits.app/image/11120.png',
    price: '0.45 ETH'
  },
  {
    id: 'meebits-775',
    name: 'Meebits #775',
    image: 'https://files.meebits.app/image/775.png',
    price: '0.68 ETH'
  },
  {
    id: 'meebits-17002',
    name: 'Meebits #17002',
    image: 'https://files.meebits.app/image/17002.png',
    price: '0.92 ETH'
  },
  {
    id: 'meebits-3918',
    name: 'Meebits #3918',
    image: 'https://files.meebits.app/image/3918.png',
    price: '0.58 ETH'
  },
  {
    id: 'meebits-7887',
    name: 'Meebits #7887',
    image: 'https://files.meebits.app/image/7887.png',
    price: '1.05 ETH'
  },
  {
    id: 'meebits-7511',
    name: 'Meebits #7511',
    image: 'https://files.meebits.app/image/7511.png',
    price: '0.414 ETH'
  },
  {
    id: 'meebits-829',
    name: 'Meebits #829',
    image: 'https://files.meebits.app/image/829.png',
    price: '0.65 ETH'
  },
  {
    id: 'meebits-18960',
    name: 'Meebits #18960',
    image: 'https://files.meebits.app/image/18960.png',
    price: '0.88 ETH'
  },
  {
    id: 'meebits-16680',
    name: 'Meebits #16680',
    image: 'https://files.meebits.app/image/16680.png',
    price: '0.55 ETH'
  },
  {
    id: 'meebits-11289',
    name: 'Meebits #11289',
    image: 'https://files.meebits.app/image/11289.png',
    price: '0.98 ETH'
  },
  {
    id: 'meebits-18174',
    name: 'Meebits #18174',
    image: 'https://files.meebits.app/image/18174.png',
    price: '0.47 ETH'
  },
  {
    id: 'meebits-12617',
    name: 'Meebits #12617',
    image: 'https://files.meebits.app/image/12617.png',
    price: '0.75 ETH'
  },
  {
    id: 'meebits-3641',
    name: 'Meebits #3641',
    image: 'https://files.meebits.app/image/3641.png',
    price: '1.12 ETH'
  },
  {
    id: 'meebits-7891',
    name: 'Meebits #7891',
    image: 'https://files.meebits.app/image/7891.png',
    price: '0.62 ETH'
  },
  {
    id: 'meebits-15305',
    name: 'Meebits #15305',
    image: 'https://files.meebits.app/image/15305.png',
    price: '0.85 ETH'
  },
  {
    id: 'meebits-3379',
    name: 'Meebits #3379',
    image: 'https://files.meebits.app/image/3379.png',
    price: '0.51 ETH'
  },
  {
    id: 'meebits-366',
    name: 'Meebits #366',
    image: 'https://files.meebits.app/image/366.png',
    price: '0.78 ETH'
  },
  {
    id: 'meebits-121',
    name: 'Meebits #121',
    image: 'https://files.meebits.app/image/121.png',
    price: '1.18 ETH'
  },
  {
    id: 'meebits-11263',
    name: 'Meebits #11263',
    image: 'https://files.meebits.app/image/11263.png',
    price: '0.44 ETH'
  },
  {
    id: 'meebits-14998',
    name: 'Meebits #14998',
    image: 'https://files.meebits.app/image/14998.png',
    price: '0.69 ETH'
  },
  {
    id: 'meebits-15964',
    name: 'Meebits #15964',
    image: 'https://files.meebits.app/image/15964.png',
    price: '0.93 ETH'
  },
  {
    id: 'meebits-15390',
    name: 'Meebits #15390',
    image: 'https://files.meebits.app/image/15390.png',
    price: '0.56 ETH'
  },
  {
    id: 'meebits-17023',
    name: 'Meebits #17023',
    image: 'https://files.meebits.app/image/17023.png',
    price: '1.08 ETH'
  },
  {
    id: 'meebits-1647',
    name: 'Meebits #1647',
    image: 'https://files.meebits.app/image/1647.png',
    price: '0.42 ETH'
  },
  {
    id: 'meebits-4511',
    name: 'Meebits #4511',
    image: 'https://files.meebits.app/image/4511.png',
    price: '0.66 ETH'
  },
  {
    id: 'meebits-13179',
    name: 'Meebits #13179',
    image: 'https://files.meebits.app/image/13179.png',
    price: '0.89 ETH'
  },
  {
    id: 'meebits-359',
    name: 'Meebits #359',
    image: 'https://files.meebits.app/image/359.png',
    price: '0.54 ETH'
  },
  {
    id: 'meebits-15927',
    name: 'Meebits #15927',
    image: 'https://files.meebits.app/image/15927.png',
    price: '0.96 ETH'
  },
  {
    id: 'meebits-2423',
    name: 'Meebits #2423',
    image: 'https://files.meebits.app/image/2423.png',
    price: '0.48 ETH'
  },
  {
    id: 'meebits-5454',
    name: 'Meebits #5454',
    image: 'https://files.meebits.app/image/5454.png',
    price: '0.72 ETH'
  },
  {
    id: 'meebits-11985',
    name: 'Meebits #11985',
    image: 'https://files.meebits.app/image/11985.png',
    price: '1.15 ETH'
  },
  {
    id: 'meebits-5299',
    name: 'Meebits #5299',
    image: 'https://files.meebits.app/image/5299.png',
    price: '0.63 ETH'
  },
  {
    id: 'meebits-16901',
    name: 'Meebits #16901',
    image: 'https://files.meebits.app/image/16901.png',
    price: '0.86 ETH'
  },
  {
    id: 'meebits-11731',
    name: 'Meebits #11731',
    image: 'https://files.meebits.app/image/11731.png',
    price: '0.53 ETH'
  },
  {
    id: 'meebits-561',
    name: 'Meebits #561',
    image: 'https://files.meebits.app/image/561.png',
    price: '0.79 ETH'
  },
  {
    id: 'meebits-17145',
    name: 'Meebits #17145',
    image: 'https://files.meebits.app/image/17145.png',
    price: '1.20 ETH'
  },
  {
    id: 'meebits-7574',
    name: 'Meebits #7574',
    image: 'https://files.meebits.app/image/7574.png',
    price: '0.46 ETH'
  },
  {
    id: 'meebits-19552',
    name: 'Meebits #19552',
    image: 'https://files.meebits.app/image/19552.png',
    price: '0.67 ETH'
  },
  {
    id: 'meebits-17542',
    name: 'Meebits #17542',
    image: 'https://files.meebits.app/image/17542.png',
    price: '0.91 ETH'
  },
  {
    id: 'meebits-12818',
    name: 'Meebits #12818',
    image: 'https://files.meebits.app/image/12818.png',
    price: '0.57 ETH'
  },
  {
    id: 'meebits-14195',
    name: 'Meebits #14195',
    image: 'https://files.meebits.app/image/14195.png',
    price: '0.99 ETH'
  },
  {
    id: 'meebits-71',
    name: 'Meebits #71',
    image: 'https://files.meebits.app/image/71.png',
    price: '0.49 ETH'
  },
  {
    id: 'meebits-2531',
    name: 'Meebits #2531',
    image: 'https://files.meebits.app/image/2531.png',
    price: '0.74 ETH'
  },
  {
    id: 'meebits-644',
    name: 'Meebits #644',
    image: 'https://files.meebits.app/image/644.png',
    price: '1.10 ETH'
  },
  {
    id: 'meebits-4439',
    name: 'Meebits #4439',
    image: 'https://files.meebits.app/image/4439.png',
    price: '0.61 ETH'
  },
  {
    id: 'meebits-812',
    name: 'Meebits #812',
    image: 'https://files.meebits.app/image/812.png',
    price: '0.85 ETH'
  },
  {
    id: 'meebits-18092',
    name: 'Meebits #18092',
    image: 'https://files.meebits.app/image/18092.png',
    price: '0.96 ETH'
  },
  {
    id: 'meebits-17917',
    name: 'Meebits #17917',
    image: 'https://files.meebits.app/image/17917.png',
    price: '0.52 ETH'
  },
  {
    id: 'meebits-14940',
    name: 'Meebits #14940',
    image: 'https://files.meebits.app/image/14940.png',
    price: '0.73 ETH'
  },
  {
    id: 'meebits-5061',
    name: 'Meebits #5061',
    image: 'https://files.meebits.app/image/5061.png',
    price: '1.15 ETH'
  },
  {
    id: 'meebits-16833',
    name: 'Meebits #16833',
    image: 'https://files.meebits.app/image/16833.png',
    price: '0.45 ETH'
  },
  {
    id: 'meebits-13465',
    name: 'Meebits #13465',
    image: 'https://files.meebits.app/image/13465.png',
    price: '0.67 ETH'
  },
  {
    id: 'meebits-7739',
    name: 'Meebits #7739',
    image: 'https://files.meebits.app/image/7739.png',
    price: '0.92 ETH'
  },
  {
    id: 'meebits-1656',
    name: 'Meebits #1656',
    image: 'https://files.meebits.app/image/1656.png',
    price: '0.58 ETH'
  },
  {
    id: 'meebits-6168',
    name: 'Meebits #6168',
    image: 'https://files.meebits.app/image/6168.png',
    price: '1.05 ETH'
  },
  {
    id: 'meebits-4037',
    name: 'Meebits #4037',
    image: 'https://files.meebits.app/image/4037.png',
    price: '0.414 ETH'
  },
  {
    id: 'meebits-100',
    name: 'Meebits #100',
    image: 'https://files.meebits.app/image/100.png',
    price: '0.65 ETH'
  },
  {
    id: 'meebits-1768',
    name: 'Meebits #1768',
    image: 'https://files.meebits.app/image/1768.png',
    price: '0.88 ETH'
  },
  {
    id: 'meebits-13437',
    name: 'Meebits #13437',
    image: 'https://files.meebits.app/image/13437.png',
    price: '0.55 ETH'
  },
  {
    id: 'meebits-2128',
    name: 'Meebits #2128',
    image: 'https://files.meebits.app/image/2128.png',
    price: '0.98 ETH'
  },
  {
    id: 'meebits-7085',
    name: 'Meebits #7085',
    image: 'https://files.meebits.app/image/7085.png',
    price: '0.47 ETH'
  },
  {
    id: 'meebits-17336',
    name: 'Meebits #17336',
    image: 'https://files.meebits.app/image/17336.png',
    price: '0.75 ETH'
  },
  {
    id: 'meebits-17059',
    name: 'Meebits #17059',
    image: 'https://files.meebits.app/image/17059.png',
    price: '1.12 ETH'
  },
  {
    id: 'meebits-7128',
    name: 'Meebits #7128',
    image: 'https://files.meebits.app/image/7128.png',
    price: '0.62 ETH'
  },
  {
    id: 'meebits-3173',
    name: 'Meebits #3173',
    image: 'https://files.meebits.app/image/3173.png',
    price: '0.85 ETH'
  },
  {
    id: 'meebits-3086',
    name: 'Meebits #3086',
    image: 'https://files.meebits.app/image/3086.png',
    price: '0.51 ETH'
  },
  {
    id: 'meebits-8893',
    name: 'Meebits #8893',
    image: 'https://files.meebits.app/image/8893.png',
    price: '0.78 ETH'
  },
  {
    id: 'meebits-3582',
    name: 'Meebits #3582',
    image: 'https://files.meebits.app/image/3582.png',
    price: '1.18 ETH'
  },
  {
    id: 'meebits-5590',
    name: 'Meebits #5590',
    image: 'https://files.meebits.app/image/5590.png',
    price: '0.44 ETH'
  },
  {
    id: 'meebits-2816',
    name: 'Meebits #2816',
    image: 'https://files.meebits.app/image/2816.png',
    price: '0.69 ETH'
  },
  {
    id: 'meebits-13936',
    name: 'Meebits #13936',
    image: 'https://files.meebits.app/image/13936.png',
    price: '0.93 ETH'
  },
  {
    id: 'meebits-10869',
    name: 'Meebits #10869',
    image: 'https://files.meebits.app/image/10869.png',
    price: '0.56 ETH'
  },
  {
    id: 'meebits-14177',
    name: 'Meebits #14177',
    image: 'https://files.meebits.app/image/14177.png',
    price: '1.08 ETH'
  },
  {
    id: 'meebits-5919',
    name: 'Meebits #5919',
    image: 'https://files.meebits.app/image/5919.png',
    price: '0.42 ETH'
  },
  {
    id: 'meebits-12287',
    name: 'Meebits #12287',
    image: 'https://files.meebits.app/image/12287.png',
    price: '0.66 ETH'
  },
  {
    id: 'meebits-8444',
    name: 'Meebits #8444',
    image: 'https://files.meebits.app/image/8444.png',
    price: '0.89 ETH'
  },
  {
    id: 'meebits-5837',
    name: 'Meebits #5837',
    image: 'https://files.meebits.app/image/5837.png',
    price: '0.54 ETH'
  },
  {
    id: 'meebits-4391',
    name: 'Meebits #4391',
    image: 'https://files.meebits.app/image/4391.png',
    price: '0.96 ETH'
  },
  {
    id: 'meebits-11720',
    name: 'Meebits #11720',
    image: 'https://files.meebits.app/image/11720.png',
    price: '0.48 ETH'
  },
  {
    id: 'meebits-11705',
    name: 'Meebits #11705',
    image: 'https://files.meebits.app/image/11705.png',
    price: '0.72 ETH'
  },
  {
    id: 'meebits-19209',
    name: 'Meebits #19209',
    image: 'https://files.meebits.app/image/19209.png',
    price: '1.15 ETH'
  },
  {
    id: 'meebits-4908',
    name: 'Meebits #4908',
    image: 'https://files.meebits.app/image/4908.png',
    price: '0.63 ETH'
  },
  {
    id: 'meebits-8473',
    name: 'Meebits #8473',
    image: 'https://files.meebits.app/image/8473.png',
    price: '0.86 ETH'
  },
  {
    id: 'meebits-4212',
    name: 'Meebits #4212',
    image: 'https://files.meebits.app/image/4212.png',
    price: '0.53 ETH'
  },
  {
    id: 'meebits-16539',
    name: 'Meebits #16539',
    image: 'https://files.meebits.app/image/16539.png',
    price: '0.79 ETH'
  },
  {
    id: 'meebits-15558',
    name: 'Meebits #15558',
    image: 'https://files.meebits.app/image/15558.png',
    price: '1.20 ETH'
  },
  {
    id: 'meebits-3175',
    name: 'Meebits #3175',
    image: 'https://files.meebits.app/image/3175.png',
    price: '0.46 ETH'
  },
  {
    id: 'meebits-1210',
    name: 'Meebits #1210',
    image: 'https://files.meebits.app/image/1210.png',
    price: '0.67 ETH'
  },
  {
    id: 'meebits-18329',
    name: 'Meebits #18329',
    image: 'https://files.meebits.app/image/18329.png',
    price: '0.91 ETH'
  },
  {
    id: 'meebits-12389',
    name: 'Meebits #12389',
    image: 'https://files.meebits.app/image/12389.png',
    price: '0.57 ETH'
  },
  {
    id: 'meebits-1327',
    name: 'Meebits #1327',
    image: 'https://files.meebits.app/image/1327.png',
    price: '0.99 ETH'
  },
  {
    id: 'meebits-2958',
    name: 'Meebits #2958',
    image: 'https://files.meebits.app/image/2958.png',
    price: '0.49 ETH'
  },
  {
    id: 'meebits-3958',
    name: 'Meebits #3958',
    image: 'https://files.meebits.app/image/3958.png',
    price: '0.74 ETH'
  },
  {
    id: 'meebits-9258',
    name: 'Meebits #9258',
    image: 'https://files.meebits.app/image/9258.png',
    price: '1.10 ETH'
  },
  {
    id: 'meebits-12688',
    name: 'Meebits #12688',
    image: 'https://files.meebits.app/image/12688.png',
    price: '0.61 ETH'
  }
  


];